<app-header></app-header>
<app-landing></app-landing>

  <div class="part1">
      <div class="searchAndProof">
        <ul class="searchAndProofMenu">
          <li class="active vertMiddle" id="menuLeft"><a id="trackShipmentButton" (click)='clicked("track")' [style.color]="fontColor1">TRACK SHIPMENT</a></li>
          <li class="vertMiddle" id="menuRight"><a id="deliveryProofButton" (click)='clicked("proof")' [style.color]="fontColor2">PROOF OF DELIVERY</a></li>
          <span id="switch" [style.transform]="transformValue"></span>
        </ul>
          <!-- <ul class="searchAndProofMenu" *ngIf="trackPageOrigin">
              <li class="active vertMiddle" id="menuLeft"><a id="trackShipmentButton" (click)='clicked("track")' style="color:white">TRACK SHIPMENT</a></li>
              <li class="vertMiddle" id="menuRight"><a id="deliveryProofButton" (click)='clicked("proof")'>PROOF OF DELIVERY</a></li>
              <span id="switch"></span>
          </ul>
          <ul class="searchAndProofMenu" *ngIf="proofPageOrigin">
              <li class="active vertMiddle" id="menuLeft"><a id="trackShipmentButton" (click)='clicked("track")' >TRACK SHIPMENT</a></li>
              <li class="vertMiddle" id="menuRight"><a id="deliveryProofButton" (click)='clicked("proof")' style="color:white">PROOF OF DELIVERY</a></li>
              <span id="switch" style="transform:translateX(100%);transition: 0.1s;"></span>
          </ul> -->
          <div class="searchAndProofImage">
              <div id="locationImageContainer" *ngIf="trackPage">
                  <img src="../../assets/image/HL prepare/location pin.png" id="locationPinImage">
                  <img src="../../assets/image/HL prepare/location pin ground.png" id="locationPinGroundImage">
              </div>
  
              <div id="imageContainer" *ngIf="proofPage">
                  <img src="../../assets/image/ICON-PROOFOFDELIVERY.png" id="proofImage">
              </div>
          </div>
      </div>
      <div class="tab-content">
          <form id="trackShipment" (submit)="getTrackerData('')" *ngIf="trackPage">
              <div id="column1" >
                  <input type="text" id="trackingNumber" placeholder="Tracking Number" [(ngModel)]="trackCode" [(value)]="trackCode" name="trackCode" >
                  <input type="submit"  class="btn" id="trackNow" value="TRACK NOW">
              </div>
          </form>
          <form id="proofDelivery" #proofForm="ngForm" ngNativeValidate (submit)="proofSubmit(proofForm)" *ngIf="proofPage">
              <div id="column2" >
                
                <h4>PROOF OF DELIVERY REQUEST FORM</h4>
                <input id="inputTrackingNumber" placeholder="Tracking Number*" [(ngModel)]="inputTrackingNumber" [(value)]="inputTrackingNumber" name="inputTrackingNumber" type="text" >
                <input id="inputSenderContactNumber" placeholder="Sender Contact Number" [(ngModel)]="inputSenderContactNumber" [(value)]="inputSenderContactNumber" name="inputSenderContactNumber" type="text" >
                <span class="orText">OR</span>
                <input id="inputReceiverContactNumber" placeholder="Receiver Contact Number" [(ngModel)]="inputReceiverContactNumber" [(value)]="inputReceiverContactNumber" name="inputReceiverContactNumber" type="text" >
                <span class="orText">OR</span>
                <input id="inputAccountNumber" placeholder="Account Number" [(ngModel)]="inputAccountNumber" [(value)]="inputAccountNumber" name="inputAccountNumber" type="text" >
                <input type="submit"  class="btn" id="submitNow" value="SUBMIT">
                  
              </div>
          </form>
          
      </div>
      <div class="result-content" id="result-content">
          <div class="trackerResult" *ngIf="trackerDisplay" id="trackerResult">
              <div *ngFor="let list of trackerListRecon" class="container-fluid">
                <div class="row">
                  <div class="col-12" id="trackerImage">
                    <img [src]="list.image" class="center-block img-responsive step-img" >
                  </div>
          
                  <div class="col-12 text-center" id="trackerID">
                      <p class="label">TRACKER ID : {{list.data['0'].WayBillNumber}}</p>    
                  </div>
                </div>
                <div *ngFor="let item of list.data; first as isFirst" class="row progress-text-row" >
                  <div class="col-md-12" style="padding:0;">
                    <div *ngIf="isFirst; else pendingJob" class="col-xs-3 col-md-2 job-done progress-text-column" >
                      <div class="col-md-12 time-col vcenter ">
                        <p class=" progress-text">{{item.LastModifiedDate}}
                          <br>{{item.LastModifiedTime}}</p>
                      </div>
                    </div>
          
                    <ng-template #pendingJob>
                      <div class="col-xs-3 col-md-2 job-pending progress-text-column" >
                          <div class="col-md-12 time-col vcenter">
                            <p class=" progress-text">{{item.LastModifiedDate}}
                              <br>{{item.LastModifiedTime}}</p>
                          </div>
                      </div>
                    </ng-template>
          
                    <div class="col-xs-9 col-md-10 progress-text-column item-description" >
                      <div class="col-md-12 detail-col vcenter">
                        <p class=" progress-text">{{item.Description}}</p>
                      </div>
                    </div>
                  </div>
                </div>
          
              </div>
          </div>
          


          <div class="proofResult" *ngIf="proofDisplay" id="proofResult">
              <div class="proofDetails">
                
              </div>
          </div>
          
      </div>
  </div>
  <app-footer class="footer"></app-footer>